import { defineMessages } from "react-intl";

export const staffDetailsPageMessages = defineMessages({
  userStatusActive: {
    id: "XMrYaA",
    defaultMessage: "User is active",
    description: "checkbox label",
  },
});
